export default __webpack_public_path__ + "static/yellow-icon-white-text-da6cf8ed08f10d081db7993eadff34cd.png";